import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'

import { getShot } from '@/api/studio-production'
import { productionBasePath } from '@/features/studio/lib/production-path'

/** 旧 `/shots/:shotId` 深链重定向到分镜工作台 */
export function LegacyShotRedirect() {
  const { productionId = '', shotId = '' } = useParams()
  const navigate = useNavigate()
  const base = productionBasePath(productionId)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      try {
        const shot = await getShot(productionId, shotId)
        if (cancelled) return
        if (shot.script_id > 0) {
          navigate(`${base}/shots/${shot.script_id}/episodes/${shot.episode_no}`, { replace: true })
          return
        }
      } catch {
        /* fall through */
      }
      if (!cancelled) navigate(`${base}/shots`, { replace: true })
    })()
    return () => {
      cancelled = true
    }
  }, [base, productionId, shotId, navigate])

  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-indigo-400" />
    </div>
  )
}
